import React from 'react';
import './styles.scss';

const Card = ({ label, icon, disabled }) => {
  return (
    <div className={`feature-card ${disabled ? 'disabled' : ''}`}>
      <div className="body">
        <img src={icon} alt={label} />
      </div>
      <div className="card-footer">{label}</div>
    </div>
  );
};

export default Card;
